import * as React from "react";
import { Theme, ThemeProvider, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { ReactComponent as CrossButton } from "../../../assets/cross.svg";
import { theme } from "../../../utils/them";
import _without from "lodash/without";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, value: readonly string[], theme: Theme) {
  return {
    fontWeight:
      value.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const SelectPlatform = ({ label, value, onChange, options,setPlatform }) => {
  // const theme = useTheme();

  const handleDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    console.log("clicked delete");
    setPlatform((current) => _without(current, value));

  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel color="secondary">{label}</InputLabel>
          <Select
            multiple
            value={value}
            color="secondary"
            onChange={onChange}
            input={<OutlinedInput id="select-multiple-chip" label={label} />}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    clickable
                    deleteIcon={
                      <CrossButton
                      className="delete-icon"
                        onMouseDown={(event) => event.stopPropagation()}
                      />
                    }
                    variant="outlined"
                    color="secondary"
                    onDelete={(e) => handleDelete(e, value)}
                    style={{borderRadius: "5px", border: "1.5px solid #48b7a7",color:"48b7a7 !important"}}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {options.map((name) => (
              <MenuItem
                key={name}
                value={name}
                style={getStyles(name, value, theme)}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
};
export default SelectPlatform;
